import { render, staticRenderFns } from "./DisciplineSelect.vue?vue&type=template&id=bc34d670&"
import script from "./DisciplineSelect.vue?vue&type=script&lang=js&"
export * from "./DisciplineSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports